{
  "CHAT_LIST": {
    "LOADING": "Beszélgetések betöltése",
    "LOAD_MORE_CONVERSATIONS": "További beszélgetések betöltése",
    "EOF": "Minden beszélgetés betöltve 🎉",
    "LIST": {
      "404": "Nincs aktív üzenetváltás ebben a csoportban."
    },
    "FAILED_TO_SEND": "A küldés sikertelen",
    "TAB_HEADING": "Beszélgetések",
    "MENTION_HEADING": "Megemlítések",
    "UNATTENDED_HEADING": "Figyelmen kívül hagyott",
    "SEARCH": {
      "INPUT": "Keresés: emberek, beszélgetése, mentett válaszok .."
    },
    "SEARCH_MESSAGES": "Beszélgetések keresése",
    "SEARCH_INPUT_PLACEHOLDER": "Beszélgetések keresése...",
    "FILTER_ALL": "Mind",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Enyém",
      "unassigned": "Gazdátlan",
      "all": "Mind"
    },
    "MESSAGE_USE_AS_TEMPLATE": "Beillesztés a válaszba",
    "CARDS": {
      "ACTIONS": {
        "OPEN": "Megnyitás",
        "BUY": "Vásárlás"
      }
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Megnyitás"
      },
      "resolved": {
        "TEXT": "Megoldva"
      },
      "pending": {
        "TEXT": "Függőben lévő"
      },
      "snoozed": {
        "TEXT": "Elnémított"
      },
      "all": {
        "TEXT": "Mind"
      }
    },
    "VIEW_FILTER": "Megtekintés",
    "SORT_TOOLTIP_LABEL": "Beszélgetések rendezése",
    "CHAT_SORT": {
      "STATUS": "Státusz",
      "ORDER_BY": "Rendezés"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": "Létrehozva",
      "LAST_ACTIVITY": "Utolsó aktivitás:",
      "LAST_CUSTOMER_MESSAGE": "Utolsó ügyfélüzenet:"
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Utolsó tevékenység: Legrégebbi először"
      },
      "last_activity_at_desc": {
        "TEXT": "Utolsó tevékenység: Legújabb először"
      },
      "last_customer_message_at_asc": {
        "TEXT": "Utolsó ügyfélüzenet: Legrégebbi először"
      },
      "last_customer_message_at_desc": {
        "TEXT": "Utolsó ügyfélüzenet: Legújabb először"
      },
      "created_at_desc": {
        "TEXT": "Készült: Legújabb először"
      },
      "created_at_asc": {
        "TEXT": "Készült: Legrégebbi először"
      },
      "priority_desc": {
        "TEXT": "Prioritás: Először a legfontosabb"
      },
      "priority_asc": {
        "TEXT": "Prioritás: Legkevésbé fontos először"
      },
      "priority_created_at_desc": {
        "TEXT": "Prioritás + Létrehozva: Legújabb először"
      },
      "priority_created_at_asc": {
        "TEXT": "Prioritás + Létrehozva: Legrégebbi először"
      },
      "waiting_since_asc": {
        "TEXT": "Függőben lévő válasz: Leghosszabb először"
      },
      "waiting_since_desc": {
        "TEXT": "Függőben lévő válasz: Legrövidebb először"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Képüzenet"
      },
      "audio": {
        "CONTENT": "Hangüzenet"
      },
      "video": {
        "CONTENT": "Videoüzenet"
      },
      "file": {
        "CONTENT": "Csatolt file"
      },
      "location": {
        "CONTENT": "Hely"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "megosztott URL-t tartalmaz"
      },
      "contact": {
        "CONTENT": "Megosztott kontakt"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Beszélgetés rendezése",
      "DROPDOWN_TITLE": "Rendezés",
      "ITEMS": {
        "LATEST": {
          "NAME": "Utolsó aktivitás",
          "LABEL": "Utolsó aktivitás"
        },
        "CREATED_AT": {
          "NAME": "Létrehozva",
          "LABEL": "Létrehozva"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Utolsó felhasználói üzenet",
          "LABEL": "Utolsó üzenet"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "E-mailen keresztül érkezett",
    "VIEW_TWEET_IN_TWITTER": "Üzenet megtekintése Twitteren",
    "REPLY_TO_TWEET": "Válasz",
    "LINK_TO_STORY": "Instagram story megnyitása",
    "SENT": "Sikeresen elküldve",
    "READ": "Olvasott",
    "DELIVERED": "Elküldve",
    "NO_MESSAGES": "Nincs üzenet",
    "NO_CONTENT": "Nincs elérhető tartalom",
    "HIDE_QUOTED_TEXT": "Idézett szöveg eltűntetése",
    "SHOW_QUOTED_TEXT": "Idézett szöveg megjelenítése",
    "HIDE_AUTOMATED_MESSAGE": "Automatikus válasz tartalmának elrejtése",
    "SHOW_AUTOMATED_MESSAGE": "Automatikus válasz tartalmának megjelenítése",
    "AUTOMATED_MESSAGE": "Automatikus válasz",
    "MESSAGE_READ": "Olvasott",
    "SENDING": "Küldés..."
  }
}
